import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { createManualBooking } from "../../lib/api";

export function AddClientRow({ artistId, onAdded }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", contact: "", source: "Instagram" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.error("Enter the client name"); return; }
    const c = form.contact.trim();
    const payload = { name: form.name.trim(), artist: artistId, source: form.source.trim() || "Instagram" };
    if (c.includes("@") && c.includes(".")) payload.email = c;
    else if (c.startsWith("@")) payload.instagram = c;
    else if (c) payload.phone = c;
    setBusy(true);
    try {
      const created = await createManualBooking(payload);
      onAdded(created);
      setForm({ name: "", contact: "", source: form.source });
      toast.success(`${created.name} added`);
    } catch {
      toast.error("Could not add client");
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid={`client-add-open-${artistId}`}
        className="w-full text-left px-4 py-3 text-[10px] tracking-[0.25em] uppercase text-[#999] hover:text-[#0A0A0A] hover:bg-[#FAFAFA] inline-flex items-center gap-2 transition-colors"
      >
        <Plus size={12} /> Add client
      </button>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`client-add-form-${artistId}`} className="grid grid-cols-12 gap-3 px-4 py-3 bg-[#FFFDF5] border-t border-[#EFEFEF] items-center">
      <input autoFocus value={form.name} onChange={set("name")} placeholder="Client name" data-testid={`client-add-name-${artistId}`} className="col-span-12 md:col-span-3 bg-transparent border-b border-[#0A0A0A] outline-none px-1 py-1 text-sm" />
      <input value={form.contact} onChange={set("contact")} placeholder="email, @instagram or phone" data-testid={`client-add-contact-${artistId}`} className="col-span-12 md:col-span-4 bg-transparent border-b border-[#0A0A0A] outline-none px-1 py-1 text-sm" />
      <input value={form.source} onChange={set("source")} placeholder="Source" data-testid={`client-add-source-${artistId}`} className="col-span-6 md:col-span-2 bg-transparent border-b border-[#0A0A0A] outline-none px-1 py-1 text-sm" />
      <div className="col-span-6 md:col-span-3 flex justify-end gap-2">
        <button type="button" onClick={() => setOpen(false)} className="text-[10px] tracking-[0.2em] uppercase text-[#999] px-2 hover:text-[#0A0A0A]">Cancel</button>
        <button type="submit" disabled={busy} data-testid={`client-add-submit-${artistId}`} className="text-[10px] tracking-[0.2em] uppercase bg-[#0A0A0A] text-white px-4 py-2 hover:opacity-80 disabled:opacity-40">Add</button>
      </div>
    </form>
  );
}
